(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-slider-track]');
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');
    if (!track || !prevBtn || !nextBtn) return;

    // How far to move per arrow click = one slide width + gap
    function getStep() {
      var slide = track.querySelector('.setup-slider__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return slide.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1; // -1 for rounding
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    // Keep arrow disabled-state in sync with manual swipe/drag scrolling too
    track.addEventListener('scroll', debounce(updateArrowState, 50));
    window.addEventListener('resize', debounce(updateArrowState, 150));

    // ---- optional: mouse-drag support for desktop (trackpad/touch already
    // works natively via the CSS overflow-x + scroll-snap on the track) ----
    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX;
      startScroll = track.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var dx = e.pageX - startX;
      track.scrollLeft = startScroll - dx;
    });

    updateArrowState();
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      var ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-setup-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-setup-slider]');
    if (el) initSlider(el);
  });
})();
